/* jshint ignore:start */
/* eslint-disable */

// DialogTriggerJS
// Copyright (c) 2016 Shahzad Malik
// MIT License
//
// Triggers a callback to pop up a dialog (or do anything else) with the specified trigger options.
//
// "trigger" can be one of the following:
//    'exit_intent': Call 'callback' when a user intends to exit (such as moving cursor off page or coming back to the top)
//    'target': Call 'callback' when a user reaches a particular target element (set 'target' to the name of the element, such as '#mytarget')
//    'scrollDown': Call 'callback' when a user scrolls down by a certain percent from when the object is instantiated (set 'percentDown' to the percentage 0-100)
//    'scrollUp': Call 'callback' when a user scrolls up by a certain percent from when the object is instantiated (set 'percentUp' to the percentage 0-100)
//    'timeout': Call 'callback' after a certain number of milliseconds have elapsed (set 'timeout' to the desired milliseconds)
//
// Examples:
// Setting up individual triggers:
//    var dt = new DialogTrigger(triggerNagPopup, { trigger: 'timeout', timeout: 5000 });
//    var dt = new DialogTrigger(triggerNagPopup, { trigger: 'target', target: '#all' });
//    var dt = new DialogTrigger(triggerNagPopup, { trigger: 'scrollDown', percentDown: 50 });
//    var dt = new DialogTrigger(triggerNagPopup, { trigger: 'exit_intent' });
//
// Triggers can also be chained for a sequence of behaviors (such as scroll down by 50%, then exit):
//    var dtPercent = new DialogTrigger(function() {
//       var dtExit = new DialogTrigger(triggerNagPopup, { trigger: 'exit_intent' });
//    }, { trigger: 'scrollDown', percentDown: 50 });
function DialogTrigger(callback, options) {
	// Becomes this.options
	var defaults = {
		trigger : 'timeout',
		target  : '',
		timeout : 0,
		percentDown : 50, // Used for 'percent' to define a down scroll threshold of significance (based on page height)
		percentUp : 10, // Used for 'percent' to define a threshold of upward scroll after down threshold is reached
		scrollInterval: 1000, // Frequency (in ms) to check for scroll changes (to avoid bogging the UI)
		userActionEvents: ['pointerdown', 'keydown', 'scroll', 'mousemove', 'touchstart'],
		userActionTimeoutFallback: 8000
	};

	this.complete = false; // Let's us know if the popup has been triggered

	this.callback = callback;
	this.timer = null;
	this.interval = null;

	this.cleanup = null;

	this.options = Object.assign( {}, defaults, options );

	this.init = function() {

		const parentThis = this;

		if ( this.options.trigger === 'exit_intent' ) {

			const onMouseLeave = ( ev ) => {
				if(!parentThis.complete && ev.clientY < 0) { // Check if the cursor went above the top of the browser window
					parentThis.callback();
					parentThis.complete = true;
					document.removeEventListener( 'mouseleave', onMouseLeave );
				}
			};

			document.addEventListener( 'mouseleave', onMouseLeave );

		} else if(this.options.trigger === 'target') {
			if(this.options.target !== '') {

				const targetEl = this.options.target instanceof HTMLElement ? this.options.target : document.querySelector( this.options.target );

				// Make sure the target exists
				if( targetEl ) {
					var rect = targetEl.getBoundingClientRect();
					var targetScroll = rect.top + window.pageYOffset;

					// Only check the scroll position every few seconds, to avoid bogging the UI
					this.interval = setInterval(function() {
						if( window.scrollY >= targetScroll ) {
							clearInterval(parentThis.interval);
							parentThis.interval = null;

							if(!parentThis.complete) {
								parentThis.callback();
								parentThis.complete = true;
							}
						}
					}, this.options.scrollInterval);
				} else {
					this.complete = true;
				}
			}

		} else if(this.options.trigger === 'scrollDown') {
			// Let the user scroll down by some significant amount
			let scrollStart = window.scrollY;
			let pageHeight = document.documentElement.scrollHeight;
			let winHeight = window.innerHeight;

			if(pageHeight > 0) {
				// Only check the scroll position every few seconds, to avoid bogging the UI
				this.interval = setInterval(function() {
					var scrollAmount = window.scrollY - scrollStart;
					if(scrollAmount < 0) {
						scrollAmount = 0;
						scrollStart = window.scrollY;
					}
					var downScrollPercent = parseFloat(scrollAmount) / parseFloat(pageHeight - winHeight);

					if(downScrollPercent > parseFloat(parentThis.options.percentDown) / 100) {
						clearInterval(parentThis.interval);
						parentThis.interval = null;

						if(!parentThis.complete) {
							parentThis.callback();
							parentThis.complete = true;
						}
					}

				}, this.options.scrollInterval);
			}

		} else if(this.options.trigger === 'scrollUp') {
			// Let the user scroll down by some significant amount
			let scrollStart = window.scrollY;
			let pageHeight = document.documentElement.scrollHeight;
			let winHeight = window.innerHeight;

			if(pageHeight > 0) {
				// Only check the scroll position every few seconds, to avoid bogging the UI
				this.interval = setInterval(function() {
					var scrollAmount = scrollStart - window.scrollY;
					if(scrollAmount < 0) {
						scrollAmount = 0;
						scrollStart = window.scrollY;
					}
					var upScrollPercent = parseFloat(scrollAmount) / parseFloat(pageHeight - winHeight);

					if(upScrollPercent > parseFloat(parentThis.options.percentUp) / 100) {
						clearInterval(parentThis.interval);
						parentThis.interval = null;

						if(!parentThis.complete) {
							parentThis.callback();
							parentThis.complete = true;
						}
					}

				}, this.options.scrollInterval);
			}

		} else if ( this.options.trigger === 'user_action' ) {
			const events = Array.isArray(this.options.userActionEvents)
				? this.options.userActionEvents
				: defaults.userActionEvents;

			let fired = false;

			const fire = () => {
				if ( fired || parentThis.complete ) return;
				fired = true;

				parentThis.complete = true;

				if ( parentThis.cleanup ) {
					parentThis.cleanup();
					parentThis.cleanup = null;
				}

				parentThis.callback();
			};

			const opts = { passive: true };
			const onEvent = () => fire();

			parentThis.cleanup = () => {
				events.forEach( (evt) => window.removeEventListener(evt, onEvent, opts) );
				if ( parentThis.timer !== null ) {
					clearTimeout(parentThis.timer);
					parentThis.timer = null;
				}
			};

			events.forEach( (evt) => window.addEventListener(evt, onEvent, opts) );

			// Fallback to fire event anyway if no user action after certain time
			if ( this.options.userActionTimeoutFallback && this.options.userActionTimeoutFallback > 0 ) {
				this.timer = setTimeout( fire, this.options.userActionTimeoutFallback );
			}

		} else if(this.options.trigger === 'timeout') {
			this.timer = setTimeout(this.callback, this.options.timeout);
		}

	};

	this.cancel = function() {
		if(this.timer !== null) {
			clearTimeout(this.timer);
			this.timer = null;
		}

		if(this.interval !== null) {
			clearInterval(this.interval);
			this.interval = null;
		}

		if ( this.cleanup ) {
			this.cleanup();
			this.cleanup = null;
		}

		this.complete = true;
	};

	this.init();
}
/* jshint ignore:end */

// Expose.
window.DialogTrigger = DialogTrigger;
export default DialogTrigger;
